import { render, staticRenderFns } from "./formUserType.vue?vue&type=template&id=3fe0d652"
import script from "./formUserType.vue?vue&type=script&lang=js"
export * from "./formUserType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports